import {IElementLikertScale, LikertScalePropertyTypes} from '../../../../../../incase-domain/elements/question/likertScale';
import {removeArrayElement, swapArrayElement, swapArrayIndices} from '../../../../../../utils/utils';

export function changeLikertScaleItemText(
    propertyName: LikertScalePropertyTypes,
    index: number,
    value: string,
    highlightedElement: IElementLikertScale,
    highlightedElementChangeHandler: {
        single: <T extends IElementLikertScale>(field: keyof T | string, value: unknown) => void;
    }
): void {
    const changedLikertScaleItem = {...highlightedElement[propertyName][index]};
    changedLikertScaleItem.text = value;
    const changedLikertScaleItemArray = swapArrayElement(highlightedElement[propertyName], index, changedLikertScaleItem);
    highlightedElementChangeHandler.single(propertyName, changedLikertScaleItemArray);
}
export function swapLikertScaleItemOrderHandler(
    propertyName: LikertScalePropertyTypes,
    newIndex: number,
    oldIndex: number,
    highlightedElement: IElementLikertScale,
    highlightedElementChangeHandler: {
        single: <T extends IElementLikertScale>(field: keyof T | string, value: unknown) => void;
    }
): void {
    const newLikertScaleQuestionsOrder = swapArrayIndices(highlightedElement[propertyName], newIndex, oldIndex);
    highlightedElementChangeHandler.single(propertyName, newLikertScaleQuestionsOrder);
}

export function removeLikertScaleItem(
    propertyName: LikertScalePropertyTypes,
    index: number,
    highlightedElement: IElementLikertScale,
    highlightedElementChangeHandler: {
        single: <T extends IElementLikertScale>(field: keyof T | string, value: unknown) => void;
    }
): void {
    const newLikertScale = removeArrayElement(highlightedElement[propertyName], index);
    highlightedElementChangeHandler.single(propertyName, newLikertScale);
}
